/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const SelectedItem = styled.div`
  height: 32px;
  background-color: #fff;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-radius: 4px;
  /* line-height: 32px; */
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  padding: 8px 0 8px 8px;
  align-items: center;
  gap: 4px;
  max-width: 180px;
`;
export const SelectedContainer = styled.div`
  padding: 12px 16px;
  display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
  background-color: ${Palette.PrimaryGray._000};
  border: 1px solid ${Palette.PrimaryGray._200};
  border-bottom: none;
  position: relative;
  //width: 1536px;
  width: 100%;
`;

export const ItemsContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 85%;
`;

export const Paragraph = styled.p`
  /* border: 1px solid red;
  display: flex;
  align-items: flex-end; */
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: ${Palette.PrimaryGray._500};
`;
